import { createContext } from 'react';
import type { GiftEditorApi } from '@yoursurprise/gift-editor';

const QuickEditorApiContext = createContext<GiftEditorApi>(
  null as unknown as GiftEditorApi,
);

export default QuickEditorApiContext;
